export class Chat {
    topic: string;
    createdDate: Date;
    content: string;
}

export class ChatRequest {
    messages: [Message];
    model_type: string;
}
export class Message {
    role: string;
    content: string;
}

export class History {
    topic: string;
    createdDate: Date;
    content: string;
}

export class Suggesstion {
    topic: string;
    createdDate: Date;
    content: string;
}

export interface ResponseModel {
    id: string;
    object: string;
    created: number;
    model: string;
    choices: choice[];
    modelUsage: usage;
}

export interface choice {
    text: string;
    index: number;
    logprobs: any;
    finish_reason: string;
}

export interface usage {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
}
export class DoctorInfo {
    full_name: string;
    age: string;
    occupation: string;
    career_high: string;
    professional_goals: string;
    profile_type: string;
}
export interface DocumentEntry {
    score: any;
    doc_name: string;
    pages: number[];
    chunk_text?: string;
    location?: string;
}
export interface ChatWithBot {
    person: string;
    response: string;
    cssClass: string;
    timestamp: Date;
    documents?: any;
    chat_conversation_id?: number;
    likedislike?: string;
    showDoc?: boolean;
    showAll?: boolean;
    regenerate?: string;
    chunkContent?: any;
    foundationModel?: boolean;
    summaryType?: string;
    synthetic_prompt?: any;
    modified_current_prompt?: any;
    id?: any;
    first_name?: any;
    disDocument?: any;
    medianChunk?: any;
    userRequest?: string;
    costInfo?: { total_tokens_utilized: number; total_cost_utilized: number };
    content?: string;
    uploadedFileHtml?: string;
    total_tokens_utilized?: number;
    total_cost_utilized?: number;
    utilization_token_json?: any;
    chunk_validation_details?: any;
    top_chunks_used?: any;
    dedup_audit_entries?: any;
    first_token_generation_time_sec?: number;
    responseSections?: ResponseSection[];
    internalResponse?: string;
    externalResponse?: string;
    internalImages?: PersistedImageItem[];
    externalImages?: PersistedImageItem[];
}

export interface PersistedImageItem {
    image_path: string;
    image_desc: string;
    /** Source reference document the image was extracted from. */
    filename?: string;
    page_number?: number;
}

export interface ResponseSection {
    answer: string;
    documents: any[];
    disDocument: any[];
    chunkContent: any[];
    showDoc?: boolean;
    showAll?: boolean;
    images?: { path: string; src: string; description?: string; loading?: boolean }[];
    showAllImages?: boolean;
}

export class RolePlayRequest {
    profile_id: number;
    user_query: string;
}

export class ChatBotRequest {
    chat_id: number;
    user_query: string;
}
export class RolePlayResponse {
    prompt: string;
    completion: string;
}

class rolePlayMetadata {
    type_name: string;
    type_value: string;
}

export class CreateRolePlayRequest {
    scenario_name: string;
    dr_profile_id: number;
    roleplay_metadata: rolePlayMetadata[];
    created_by: number;
    updated_by: number;
}
export class TraineeSummary {
    wwid: number;
    first_name: string;
    last_name: string;
    session_count: number;
    roleplay_completed: number;
    roleplay_pending: number;
    roleplay_total_count: number;
    test_score: number;
    roleplay_score: number;
    email: string;
    user_session_list?: Array<UserSessionList>
}
export class UserSessionList {
    chat_type: string;
    chat_start_time: string;
    chat_topic: string;
    total_hours: number;
    total_minutes: number;
    total_seconds: number;
    session_score: number;
    session_roleplay_scores: number;
    feedback_id?: number;
    trainer_feedback?: string;
}

export class UserProfile {
    wwid: number;
    first_name: string;
    last_name: string;
    email: string;
    user_type: string;
    created_by: string;
    created_date: Date;
    updated_by: string;
    updated_date: Date;
    status: string;
    role_name: string;
    role_label: string;
    default_business_unit_code: string;
    product: Array<any>;
    default_primary_market: string[];
    default_primary_region: string[];
}

export interface SystemPrompt {
    system_prompt: string;
    config_module: string;
    created_by: number;
    created_date: string;
    prompt_stage: string;
    updated_by: number;
    updated_date: string;
}
export interface CustomizeDetails {
    enable_voice_interaction?: boolean;
    enable_video_interaction?: boolean;
    photo_avatar_enabled?: boolean;
}
